export default __webpack_public_path__ + "static/media/1034_1036_nåtade_teakbord_kompass_oval.fa032b85.jpg";